import React from 'react';
import { CheckIcon } from 'lucide-react';
import { OfferCard } from '../OfferCard';
import { images, purchaseIncludes, valueStack } from '../../data/content';
export function ValueStack() {
  return <section id="offer" className="bg-navy-900 px-5 py-16 text-white md:py-24" aria-labelledby="stack-title" data-id="element-340" data-mp="1gtj0ebdsamdn">
      <div className="mx-auto max-w-6xl" data-id="element-341" data-mp="1bv96s57pjtu5">
        <p className="text-center font-display text-xs font-extrabold uppercase tracking-[0.14em] text-gold sm:text-sm" data-id="element-342" data-mp="1bs3igs6wkvzh">
          Special introductory offer
        </p>
        <h2 id="stack-title" className="mt-3 text-center font-display text-3xl font-black leading-tight sm:text-5xl text-balance" data-id="element-343" data-mp="k4l58s24gmfy">
          Here’s Everything You’ll Receive Today
        </h2>

        <div className="mt-12 grid gap-10 lg:grid-cols-2 lg:items-start" data-id="element-344" data-mp="t2wtinfin858">
          <div data-id="element-345" data-mp="5dc8lyzsy0tb">
            <img src={images.mockup} alt="Complete ECG Interpretation Blueprint™ collection" className="mx-auto w-full max-w-md rounded-3xl bg-white p-2" data-id="element-346" data-mp="5d2jedmkzxoo" />

            <div className="mt-8 rounded-3xl bg-navy-950 p-5 sm:p-7" data-id="element-347" data-mp="2jq24n1zpnjqx">
              <h3 className="font-display text-sm font-extrabold uppercase tracking-wider text-gold" data-id="element-348" data-mp="2jpsg7iubdknc">
                Your complete ECG educational collection
              </h3>
              <ul className="mt-4 divide-y divide-white/10" data-id="element-349" data-mp="2th6mqakonkpz">
                {valueStack.map(row => <li key={row.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-350" data-mp="2yef62ehkhust">
                    <span className="text-[15px] font-medium leading-snug text-white/90" data-id="element-351" data-mp="20sr8hq9dl6fp">{row.label}</span>
                    <span className="shrink-0 font-display text-base font-extrabold text-white/60 line-through" data-id="element-352" data-mp="25qjaxe7ncay5">
                      ${row.value}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-3 flex items-center justify-between gap-4 border-t-2 border-white/30 pt-4" data-id="element-353" data-mp="3m4j6kczglefl">
                <span className="font-display text-base font-extrabold uppercase" data-id="element-354" data-mp="3q5uqq2zkd7ge">Total illustrative value</span>
                <span className="font-display text-xl font-black text-pulse line-through decoration-2" data-id="element-355" data-mp="1r0l6t16qdofe">$237 USD</span>
              </div>
              <div className="mt-4 flex items-center justify-between gap-4 rounded-2xl bg-gold px-4 py-3 text-navy-950" data-id="element-356" data-mp="1m204mw7x4uob">
                <span className="font-display text-base font-black uppercase" data-id="element-357" data-mp="1zzor28hmw9vh">Today: just</span>
                <span className="font-display text-3xl font-black" data-id="element-358" data-mp="1v152e0bnojzf">$27 USD</span>
              </div>
            </div>

            <h3 className="mt-8 font-display text-sm font-extrabold uppercase tracking-wider text-gold" data-id="element-359" data-mp="13bs3gjns4ear">
              Your purchase includes
            </h3>
            <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-360" data-mp="1h4rn8xulguo4">
              {purchaseIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] font-semibold text-white" data-id="element-361" data-mp="1cadkgadlrl9f">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-heal" data-id="element-362" data-mp="okj9jycug6rt">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-363" data-mp="2vb61c86q292u" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:sticky lg:top-6" data-id="element-364" data-mp="2maq075dgbe15">
            <OfferCard ctaLabel="Yes! I want the complete Blueprint™ for $27" data-id="element-365" data-mp="2mc17vga0p5xj" />
            <p className="mt-4 text-center text-xs text-white/55" data-id="element-366" data-mp="2ram4z6tz39hr">
              The comparison values above are illustrative offer-positioning estimates, not verified retail prices.
            </p>
          </div>
        </div>
      </div>
    </section>;
}